import React from "react";
import { Link } from "react-router-dom";
import BrassRule from "@/components/BrassRule";
import { useLang } from "@/lib/i18n";

export default function NotFound() {
  const { t } = useLang();
  return (
    <section
      data-testid="notfound-page"
      className="relative min-h-screen flex items-center justify-center bg-charcoal text-ivory overflow-hidden"
    >
      <img
        src="/static/experiences/aracena-riotinto/hero.png"
        alt=""
        className="absolute inset-0 w-full h-full object-cover page-hero-kb opacity-40"
      />
      <div
        className="absolute inset-0"
        style={{ background: "linear-gradient(180deg, rgba(15,15,15,0.55) 0%, rgba(15,15,15,0.35) 50%, rgba(15,15,15,0.80) 100%)" }}
        aria-hidden
      />
      <div className="relative z-10 text-center px-6 max-w-2xl hero-legible">
        <p className="eyebrow text-brass">{t.notfound.eyebrow}</p>
        <h1 className="font-display text-ivory mt-6 leading-[1.05] text-balance" style={{ fontSize: "clamp(2.5rem, 6vw, 4.5rem)" }}>
          {t.notfound.title}{" "}
          <span className="italic-quote font-normal" style={{ fontWeight: 400 }}>{t.notfound.italic}</span>
        </h1>
        <BrassRule className="mt-8" width={60} />
        <p className="italic-quote text-ivory/85 mt-8" style={{ fontSize: "clamp(1.1rem, 1.4vw, 1.3rem)" }}>
          {t.notfound.sub}
        </p>
        <Link to="/experiences" className="btn-brass text-ivory mt-10 inline-flex">
          {t.notfound.cta}
        </Link>
      </div>
    </section>
  );
}
